// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_33mmg","headline":"_3zOrq","icon-wrapper":"_YZl_","collection-name":"_2APVK","content":"nLyxB","stories":"_2dus4"};